const BASE_URL = '/authentication/destination';

export class DestinationService {
    /* @ngInject */
    constructor($http, egUrlService, $cookies) {
        this.$http = $http;
        this.egUrlService = egUrlService;
        this.$cookies = $cookies;
    }

    clear(){
        this.$cookies.remove('x-egto-worker-name');
        this.$cookies.remove('x-egto-destination-resource');
    }

    getDestinationInstallation() {
        let url = this.egUrlService.url(`${BASE_URL}/installation`);
        return this.$http.get(url)
            .then(response => response.data);
    }

    getDestinationOrganization() {
        let url = this.egUrlService.url(`${BASE_URL}/organization`);
        return this.$http.get(url)
            .then(response => response.data);
    }

    getDestinationSecurityContext() {
        let url = this.egUrlService.url(`${BASE_URL}/securityContext`);
        return this.$http.get(url)
            .then(response => response.data);
    }
}
